export const calculateSimilalityScore = (score: number) => {
  return (100 - score * 50).toFixed(1)
}
